import BenchlingConfig from 'BenchlingConfig';

// Keep in sync with benchling/config_migration/tenant_diff/constants.py
export enum CustomerEnablementType {
  HIDDEN = 'HIDDEN',
  VISIBLE = 'VISIBLE',
  ENABLED = 'ENABLED',
}

// Keep in sync with benchling/config_migration/tenant_diff/constants.py
export enum ValidationReportType {
  INTERNAL = 'INTERNAL',
  EXTERNAL = 'EXTERNAL',
}

/**
 * Returns true if the user is a tenant admin and the tenant comparison feature is ENABLED or only VISIBLE.
 */
export function isTenantComparisonVisible(): boolean {
  return BenchlingConfig.ENABLE_EXTERNAL_TENANT_COMPARISON !== CustomerEnablementType.HIDDEN;
}

/**
 * Sent to gainsight events when requesting access to the beta
 */
export const TENANT_COMPARISON_RELEASE_VALUE = 'Tenant Comparison Report';
